import React from "react";

export const XiaomiLink = () => (
  <a
    href="https://global.app.mi.com/details?lo=ES&la=en&id=com.sgiggle.production"
    target="_blank"
    rel="noreferrer"
  >
    Xiaomi GetApps
  </a>
);
export const SamsungLink = () => (
  <a
    href="https://galaxystore.samsung.com/detail/com.sgiggle.production"
    target="_blank"
    rel="noreferrer"
  >
    Samsung Galaxy Store
  </a>
);
export const HuaweiLink = () => (
  <a
    href="https://appgallery.huawei.com/app/C105350361"
    target="_blank"
    rel="noreferrer"
  >
    Huawei AppGallery
  </a>
);

export const APKLink = () => (
  <a
    href="https://tangosocials.me/tango-android-8.81.1733431846-arm64.apk"
    target="_blank"
    rel="noreferrer"
  >
    Download APK
  </a>
);

export const GoogleStoreLink = ({text}) => (
  <a
    href="https://play.google.com/store/apps/dev?id=8737235647131488610&hl=en&pli=1"
    target="_blank"
    rel="noreferrer"
  >
    {text}
  </a>
);


